/**
 * Shared width for the Best-in-Dental dialogs (application popup + winner banner).
 * The Figma panel width sits between the DS Dialog `size` variants
 * (small=250, medium=620), so both dialogs render at `size="small"` and
 * override `maxWidth` to this value for a consistent panel width.
 */
export const BID_DIALOG_MAX_WIDTH = 358;

export const BID_DIALOG_STYLE = { maxWidth: BID_DIALOG_MAX_WIDTH } as const;
